import type { Dispatch, SetStateAction } from "react";

export type AddressFormFields = {
  label: string;
  name: string;
  phone: string;
  address1: string;
  address2: string;
  postcode: string;
  city: string;
  state: string;
  country: string;
  isDefault: boolean;
};

export function emptyAddressForm(displayName = "", isDefault = true): AddressFormFields {
  return {
    label: "Home",
    name: displayName,
    phone: "",
    address1: "",
    address2: "",
    postcode: "",
    city: "",
    state: "",
    country: "MY",
    isDefault,
  };
}

export function patchAddressForm(
  set: Dispatch<SetStateAction<AddressFormFields>>,
  patch: Partial<AddressFormFields> | ((prev: AddressFormFields) => Partial<AddressFormFields>),
) {
  set((prev) => ({
    ...prev,
    ...(typeof patch === "function" ? patch(prev) : patch),
  }));
}
